export function getS3TranslationsUrl(locale: string, cacheBuster?: string): string {
	// this should only be used in development and the staging domain accepts the local domains for CORS
	return `https://static.staging-change.org/i18n/production/${locale}.json${cacheBuster ? `?${cacheBuster}` : ''}`;
}
